import { EQueryStringFilters } from '../types/queryStringFilters';
import { IGetFiltersResponseV2Schema } from '../common/repositories/job-vacancies-backend/entities/filters/GetFiltersResponseV2Schema';

interface IPrepareFilterValues {
  filterName: EQueryStringFilters;
  qsValues: string[];
  filters?: IGetFiltersResponseV2Schema;
}

/**
 * Подготавливает валидные наборы значений фильтров из get-параметров
 */
export const prepareFilterValues = ({ filterName, qsValues, filters }: IPrepareFilterValues) => {
  /** Ничего не делает, если нет словаря фильтров */
  if (!filters) {
    return [];
  }

  /** Отфильтровывает только валидные значения фильтра по тегам */
  if (filterName === EQueryStringFilters.Tags) {
    const tagFilters = filters.tagFilters;
    const possibleValues = tagFilters.map(tagFilter => tagFilter.value);

    return qsValues.filter(qsValue => possibleValues.includes(qsValue));
  }

  /** Ничего не делает, если нет фильтров типа Селект */
  if (!filters.filters) {
    return [];
  }

  /** Выбирает подходящий по имени фильтр типа Селект из словаря */
  const filter = filters.filters.find(filter => filter.name === filterName);

  /** Отфильтровывает только валидные значения фильтра типа Селект */
  if (filter) {
    const possibleValues = filter.options.map(option => option.value);

    return qsValues.filter(qsValue => possibleValues.includes(qsValue));
  }

  /** Ничего не делает, если фильтра нет в словаре */
  return [];
};
